<div [classList]="classList" [style]="responsiveStyle$ | async">
    <ng-content></ng-content>
</div>
